"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifyIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class NotifyIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("g", { transform: "translate(5.000000, 5.000000)" },
                        React.createElement("path", { d: "M13.7083333,10.5 C12.9045,10.5 12.25,9.84608333 12.25,9.04166667 L12.25,6.41666667 C12.25,4.29275 10.9433333,2.36191667 8.98158333,1.56041667 C8.76283333,0.646333333 7.95491667,0 7,0 C6.05966667,0 5.236,0.65975 5.01666667,1.56041667 C3.05608333,2.36191667 1.75,4.29216667 1.75,6.41666667 L1.75,9.04166667 C1.75,9.84608333 1.0955,10.5 0.291666667,10.5 C0.130666667,10.5 0,10.6306667 0,10.7916667 C0,10.9526667 0.130666667,11.0833333 0.291666667,11.0833333 L13.7083333,11.0833333 C13.8693333,11.0833333 14,10.9526667 14,10.7916667 C14,10.6306667 13.8693333,10.5 13.7083333,10.5" }),
                        React.createElement("path", { d: "M8.75,11.6666667 L5.25,11.6666667 C5.089,11.6666667 4.95833333,11.7973333 4.95833333,11.9583333 C4.95833333,13.0841667 5.87416667,14 7,14 C8.12583333,14 9.04166667,13.0841667 9.04166667,11.9583333 C9.04166667,11.7973333 8.911,11.6666667 8.75,11.6666667" }))))));
    }
}
exports.NotifyIcon = NotifyIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/notify.tsx
// module id = 2153
// module chunks = 0 1 2